export const reducer = (state, action) => {
    const {type} = action;
    const {views} = state;
    switch (type) {
        case 'NAVIGATE_YES':
            const {Thanks} = views;
            return {
                ...state,
                CurrentView: Thanks
            };
        case 'NAVIGATE_NO':
            const {ThanksNo} = views;
            return {
                ...state,
                CurrentView: ThanksNo
            };
        default:
            return state;
    }
};
